import React, { ReactElement } from 'react';

import { ContainerWithMaxWidth } from '@/core/components/ContainerWithMaxWidth';
import type { BannerSlot } from '@/core/lib/ads/ads.context';

interface DetailsLayoutProps extends React.PropsWithChildren {
  adSlot: BannerSlot;
  sideComponent?: ReactElement;
}

const DetailsLayout: React.FC<DetailsLayoutProps> = ({ children, sideComponent }) => (
  <main id="app" className="w-full flex-col pt-space-header lg:bg-bg-pale">
    <ContainerWithMaxWidth noPaddingXMobile>
      <div className="grid w-full md:grid-cols-8 lg:grid-cols-12 lg:gap-6">
        <div className="md:col-span-8 lg:col-span-8">{children}</div>
        <div className="justify-end space-y-8 md:col-span-8 lg:col-span-4 lg:pb-6">
          {sideComponent}
          <div className="sticky right-0 top-[84px] size-fit max-lg:hidden">
            <div className="min-h-[620px] w-[320px]" dangerouslySetInnerHTML={{ __html: `<div class="HalfpageAd_1" style="display:none;"></div>` }}></div>
          </div>
        </div>
      </div>
    </ContainerWithMaxWidth>
  </main>
);

export default DetailsLayout;
